import { Command } from "./index";
import { Icon } from "@chakra-ui/react";
import { GiRainbowStar } from "react-icons/gi";
import { insertSurroundingText } from "../utils/insertSurroundingText";

export const scribbleRainbow: Command = {
  category: "effect",
  icon: <Icon as={GiRainbowStar} />,
  name: "rainbow",
  tooltip: "tag with rainbow effect",
  execute: (editorRef) => insertSurroundingText(editorRef, "{{#rainbow}}", "{{/rainbow}}"),
};
